import { CV_ORIGINAL_MARK_HEIGHT, CV_ORIGINAL_MARK_WIDTH, DD_ORIGINAL_MARK_HEIGHT, DD_ORIGINAL_MARK_WIDTH, DEFAULT_PROPS, LogoBrands, PROP_TYPES, markWidthForSize } from './constants';
import React from 'react';
export var DoorDashLogoMark = function DoorDashLogoMark(_ref) {
  var color = _ref.color,
      size = _ref.size;
  return React.createElement("svg", {
    width: markWidthForSize(size, LogoBrands.DoorDash),
    height: size,
    viewBox: "0 0 ".concat(DD_ORIGINAL_MARK_WIDTH, " ").concat(DD_ORIGINAL_MARK_HEIGHT),
    fill: color
  }, React.createElement("path", {
    d: "M95.64,13.38A25.24,25.24,0,0,0,73.27,0H2.43A2.44,2.44,0,0,0,.72,4.16L16.15,19.68a7.26,7.26,0,0,0,5.15,2.14H71.24a6.44,6.44,0,1,1,.13,12.88H36.94a2.44,2.44,0,0,0-1.72,4.16L50.66,54.39a7.25,7.25,0,0,0,5.15,2.14H71.38c20.26,0,35.58-21.66,24.26-43.16"
  }));
};
DoorDashLogoMark.propTypes = PROP_TYPES;
DoorDashLogoMark.defaultProps = DEFAULT_PROPS;
export var CaviarLogoMark = function CaviarLogoMark(_ref2) {
  var color = _ref2.color,
      size = _ref2.size;
  return React.createElement("svg", {
    width: markWidthForSize(size, LogoBrands.Caviar),
    height: size,
    viewBox: "0 0 ".concat(CV_ORIGINAL_MARK_WIDTH, " ").concat(CV_ORIGINAL_MARK_HEIGHT),
    fill: color
  }, React.createElement("path", {
    d: "M25.04 34.7a9.65 9.65 0 1 0 19.3 0 9.65 9.65 0 0 0-19.3 0M59.5 57.34L52.2 50a1.7 1.7 0 0 0-2.42 0 21.58 21.58 0 0 1-14.98 6.1 21.11 21.11 0 0 1-21.04-21.14A21.11 21.11 0 0 1 34.8 13.82c5.14 0 9.82 1.85 13.63 5.17.67.6 1.7.58 2.33-.07l7.3-7.32a1.7 1.7 0 0 0-.08-2.5C51.61 3.37 43.61 0 34.8 0 15.61 0 0 15.68 0 34.96 0 54.23 15.61 69.9 34.8 69.9c9.45 0 18.27-3.74 24.7-10.14.67-.67.67-1.76 0-2.43",
    fillRule: "evenodd"
  }));
};
CaviarLogoMark.propTypes = PROP_TYPES;
CaviarLogoMark.defaultProps = DEFAULT_PROPS;